import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'SalesLineItem',
    column_type: 'id',
  },
  created_at: {
    model_name: 'SalesLineItem',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'SalesLineItem',
    column_type: 'datetime',
  },
  sales_order: {
    model_name: 'SalesLineItem',
    column_type: 'belongs_to',
    extra: {
      association_name: 'sales_order',
      model_name: 'SalesOrder',
    },
  },
  sales_order_id: {
    model_name: 'SalesLineItem',
    column_type: 'belongs_to',
    extra: {
      association_name: 'sales_order',
      model_name: 'SalesOrder',
    },
  },
  jushuitan_sku: {
    model_name: 'SalesLineItem',
    column_type: 'belongs_to',
    extra: {
      association_name: 'jushuitan_sku',
      model_name: 'JushuitanSKU',
    },
  },
  style_number: {
    model_name: 'SalesLineItem',
    column_type: 'belongs_to',
    extra: {
      association_name: 'jushuitan_sku',
      model_name: 'JushuitanSKU',
    },
  },
  cost: {
    model_name: 'SalesLineItem',
    column_type: 'decimal',
  },
  cost_price: {
    model_name: 'SalesLineItem',
    column_type: 'string',
  },
  price: {
    model_name: 'SalesLineItem',
    column_type: 'decimal',
  },
  quantity: {
    model_name: 'SalesLineItem',
    column_type: 'integer',
  },
  fully_shipped: {
    model_name: 'SalesLineItem',
    column_type: 'boolean',
  },
  shipped_info: {
    model_name: 'SalesLineItem',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
